module.exports = __webpack_public_path__ + "static/media/title_dlc_03.a7154d6c.png";